import { useTranslation } from 'react-i18next'
import { Button, IconButton, InputAdornment, TextField } from '@mui/material'

// import { Payment } from '../../types'
import SearchIcon from '../../assets/icons/search-icon.svg'
import DownloadIcon from '../../assets/icons/download-icon.svg'
import { Document, FormError, UserSessionType } from '../../types'
import { baseButtonTextWhiteBg, textFieldWhiteBg } from '../../theme/custom-styles'
import { countriesCurrencies } from '../../lib'

const ActionsBar = ({
  errors,
  userSession,
  documentData,
  /* paymentsData, */
  paymentToSearch,
  totalOfPayments,
  amountOfPayments,
  searchingInDatabase,
  handleDownloadReport,
  handleClearSearchInput,
  handleDownloadCSVReport,
  handleSetPaymentToSearch
}: {
  errors: FormError
  paymentToSearch: string
  totalOfPayments: string
  amountOfPayments: string
  searchingInDatabase?: boolean
  userSession: UserSessionType
  documentData: Partial<Document>
  handleDownloadReport?: () => void
  handleClearSearchInput: () => void
  handleDownloadCSVReport?: () => void
  /* paymentsData: Array<Partial<Payment>> */
  handleSetPaymentToSearch: (paymentToSearch: string, showError: boolean) => void
}) => {
  const selectedCountry = globalThis.sessionStorage.getItem('selectedCountry') || 'COL'
  const currency = (countriesCurrencies as { [key: string]: string })[selectedCountry].toUpperCase()

  const { t } = useTranslation(['document-payments-details-management'])

  return (
    <div className="documents-actions-bar-container">
      <div className="documents-payments-details-actions-bar-left">
        {(documentData.status === 'completed' || documentData.status === 'dispersing' || documentData.status === 'register-disperse-completed') && userSession && userSession.role.indexOf('-client') > -1 && (
          <>
            <Button
              fullWidth
              variant="text"
              sx={baseButtonTextWhiteBg}
              startIcon={
                <img
                  src={DownloadIcon}
                  alt="download-icon"
                />
              }
              className="users-management-actions-bar-button-action"
              onClick={() => handleDownloadReport?.()}
            >
              <div className="users-management-actions-bar-button-action-text">{t('downloadReportText')}</div>
            </Button>
            <Button
              fullWidth
              variant="text"
              sx={baseButtonTextWhiteBg}
              startIcon={
                <img
                  src={DownloadIcon}
                  alt="download-icon"
                />
              }
              className="users-management-actions-bar-button-action"
              onClick={() => handleDownloadCSVReport?.()}
            >
              <div className="users-management-actions-bar-button-action-text">{t('downloadReportTextCSV')}</div>
            </Button>
          </>
        )}
        <div
          className="documents-payments-details-actions-bar-check-option"
          style={{ width: '100%' }}
        >
          <div className="documents-actions-bar-check-option-text">{t('actionsBar.totalOfPayments', { currency, totalOfPayments, amountOfPayments })}</div>
        </div>
      </div>
      <div className="documents-actions-bar-right">
        <TextField
          variant="standard"
          sx={textFieldWhiteBg}
          disabled={searchingInDatabase}
          label={t('searchField.placeholder')}
          value={paymentToSearch}
          error={!!errors.paymentToSearch}
          helperText={errors.paymentToSearch}
          className="documents-actions-bar-search-input"
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault()
              handleSetPaymentToSearch(paymentToSearch, true)
            }
          }}
          onChange={(event) => {
            handleSetPaymentToSearch(event.target.value, true)
          }}
          onBlur={() => {
            if (paymentToSearch === '') handleClearSearchInput()
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  aria-label="toggle password visibility"
                  sx={{ color: '#107569', right: '10px', bottom: '3px' }}
                >
                  <img
                    src={SearchIcon}
                    alt="search-icon"
                  />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      </div>
    </div>
  )
}

export default ActionsBar
